import { STYLES } from "../utils/customStyles";
import { STRINGS } from "../utils/string";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\+?[1-9]\d{1,14}$/;

export function validateName(name) {
  if (!name || name.trim() === "") {
    throw STRINGS.ERROR_MAPPING.NAME_REQD;
  }
}

export function validateEmail(email) {
  if (email && email.trim() !== "" && !emailRegex.test(email)) {
    throw STRINGS.ERROR_MAPPING.EMAIL_INVLD;
  }
}

export function validatePhone(phone) {
  if (phone && phone.trim() !== "" && !phoneRegex.test(phone)) {
    throw STRINGS.ERROR_MAPPING.PHONE_INVLD;
  }
}

export function validateContactInfo(email, phone) {
  if ((!email || email.trim() === "") && (!phone || phone.trim() === "")) {
    throw STRINGS.ERROR_MAPPING.EMAIL_OR_PHONE_REQD;
  }
}

export function getMenuList(fieldOptions, openAddModal) {
  return {
    menuListItems: fieldOptions.map((fieldOption) => ({
      key: fieldOption.key,
      name: fieldOption.value,
      onClick: () => openAddModal(fieldOption),
      props: { sx: STYLES.menuItemStyle },
    })),
    props: {
      PaperProps: { sx: STYLES.menuListStyle },
      anchorOrigin: { vertical: "bottom", horizontal: "left" },
      transformOrigin: { vertical: "top", horizontal: "center" },
    },
  };
}
